import { render, staticRenderFns } from "./ReportsDeliveryShipperView.vue?vue&type=template&id=4670ba8c"
import script from "./ReportsDeliveryShipperView.vue?vue&type=script&lang=ts"
export * from "./ReportsDeliveryShipperView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports